export const searchContextSymbol = Symbol( 'search-context' );

/****************************** Persistence Keys *****************************/
export const  ArticlesPrimaryKey: string = 'id' as const;
export const  ArticlesPrimaryIndexKey: string = 'slug' as const;
export const  AuthorsPrimaryKey: string = 'id' as const;
export const  AuthorsPrimaryIndexKey: string = 'slug' as const;
export const  BonusReportsPrimaryKey: string = 'id' as const;
export const  BonusReportsPrimaryIndexKey: string = 'slug' as const;
export const  BonusReportsSecondaryIndexKey: string = 'name' as const;
export const  CategoriesPrimaryKey: string = 'id' as const;
export const  CategoriesPrimaryIndexKey: string = 'slug' as const;
export const  CategoriesSecondaryIndexKey: string = 'name' as const;
export const  IndustrySectorsPrimaryKey: string = 'id' as const;
export const  IndustrySectorsPrimaryIndexKey: string = 'slug' as const;
export const  ModelPortfolioPrimaryKey: string = 'key' as const;
export const  PermissionsPrimaryKey: string = 'key' as const;
export const  ProductsPrimaryKey: string = 'id' as const;
export const  ProductsPrimaryIndexKey: string = 'slug' as const;
export const  SectorsPrimaryKey: string = 'id' as const;
export const  SectorsPrimaryIndexKey: string = 'symbol' as const;
export const  SectorAlertsPrimaryKey: string = 'id' as const;
export const  SectorAlertsPrimaryIndexKey: string = 'sector_id' as const;
export const  SectorAlertsSecondaryIndexKey: string = 'date' as const;
export const  SectorHistoryPrimaryKeyDate: string =  'dt' as const;
export const  SectorHistoryPrimaryKeySectorId: string = 'id' as const;
export const  SectorHistoryPrimaryIndexKey: string = 'dt' as const;
export const  SectorHistorySecondaryIndexKey: string = 'id' as const;
export const  SimplePagesPrimaryKey: string = 'id' as const;
export const  SimplePagesPrimaryIndexKey: string = 'slug' as const;
export const  TagsPrimaryKey: string = 'id' as const;
export const  TagsPrimaryIndexKey: string = 'slug' as const;
export const  TickersPrimaryKey: string = 'id' as const;
export const  TickersPrimaryIndexKey: string = 'symbol' as const;
export const  TradeAlertsPrimaryKey: string = 'id' as const;
export const  TradeAlertsPrimaryIndexKey: string = 'slug' as const;
export const  WebinarsPrimaryKey: string = 'id' as const;
export const  WebinarsPrimaryIndexKey: string = 'slug' as const;

/****************************** ERROR PAGES ******************************/
export const  NotFoundName: string = 'not-found' as const;
export const  NotFoundCode: string = `404` as const;
export const  NotFoundPath: string = `/${ NotFoundName }` as const;

/********************************* ONE-OFF ***********************************/
export const  DarkShadowsWeeklyShortCode: string = 'dsw' as const;
export const  DarkMoneyIndicatorShortCode: string = 'dml' as const;

/******************************* PRODUCTS ********************************/
export const  CheckPointTraderSlug: string = 'checkpoint-trader' as const;
export const  DarkMoneyIndicatorSlug: string = 'dark-money-indicator' as const;
export const  DeepMarketTraderSlug: string = 'deep-market-trader' as const;
export const  MonthlyTrendTraderSlug: string = 'monthly-trend-trader' as const;
export const  OptionsSoupSlug: string = 'options-soup' as const;
export const  ProfitSkimmerSlug: string = 'profit-skimmer' as const;
export const  SectorFocusSlug: string = 'sector-focus' as const;
export const  SectorProphetsSlug: string = 'sector-prophets' as const;
export const  TechnicalAnalysisMillionaireSlug: string = 'technical-analysis-millionaire' as const;
export const  MegaTrendProfitClubSlug: string = 'mega-trend-profit-club' as const;
export const  SmallCapCashCowsSlug: string = 'small-cap-cash-cows' as const;
export const  TrueSovereignProfitsSlug: string = 'true-sovereign-profits' as const;

/***************************** MENU OPTIONS ******************************/
export const  LatestArticlesView: string = 'latest-articles' as const;
export const  LessonsView: string = 'lessons' as const;
export const  ModelPortfolioView: string = 'model-portfolio' as const;
export const  SectorAlertsView: string = 'alerts' as const;
export const  ToolsView: string = 'tools' as const;
export const  TradeAlertsView: string = 'trade-alerts' as const;
export const  WebinarsView: string = 'webinars' as const;

/*********************** CONTENT MODEL "type" keys ***********************/
export const  Alerts: string = 'alerts' as const;
export const  Articles: string = 'articles' as const;
export const  Authors: string = 'authors' as const;
export const  BonusReports: string = 'bonus-reports' as const;
export const  PublicBonusReports: string = 'public-bonus-reports' as const;
export const  Categories: string = 'categories' as const;
export const  Commentary: string = 'commentary' as const;
export const  IndustrySectors: string = 'industry-sectors' as const;
export const  ModelPortfolios: string = 'model-portfolio' as const;
export const  Permissions: string = 'permissions' as const;
export const  ProductsContentType: string = 'products' as const;
export const  PublicArticles: string = 'public-articles' as const;
export const  Sectors: string = 'sectors' as const;
export const  SectorAlerts: string = 'sector-alerts' as const;
export const  SectorBreadth: string = 'sector-breadth' as const;
export const  SectorHistory: string = 'sector-history' as const;
export const  SimplePages: string = 'simple-pages' as const;
export const  Tags: string = 'tags' as const;
export const  Testimonials: string = 'testimonials' as const;
export const  Tickers: string = 'tickers' as const;
export const  TradeAlerts: string = 'trade-alerts' as const;
export const  User: string = 'user' as const;
export const  Webinars: string = 'webinars' as const;
export const  StaticContent: string = 'static-content' as const;

/**************************** GENERAL Constants **************************/
export const  UndefinedNumber: number = -1 as const;
export const  MissingDataString: string = '---' as const;

/**************************** SECTOR Constants **************************/
export const  AllKey: string = 'all' as const;
export const  AllDisplay: string = 'Latest' as const;
export const  BullishPercentIndexKey: string = 'bpi' as const;
export const  BullishPercentIndexDisplay: string = 'Sector Demand' as const;
export const  BullishPercentIndexHint: string = '&nbsp;("When" to own)' as const;
export const  PercentThirtyWeekKey: string = 'wk' as const;
export const  PercentThirtyWeekDisplay: string = 'Precision Timing' as const;
export const  Week: string = 'week' as const;
export const  RelativeStrengthKey: string = 'rs' as const;
export const  SectorRelativeStrengthDisplay: string = 'Sector Strength' as const;
export const  RelativeStrengthHint: string = '&nbsp;("What" to Own)' as const;
export const  Sector: string = 'sector' as const;
export const  TotalSectors: number = 45 as const;

/****************************** Permissions Keys *****************************/
export const  ArticlesKey: string = 'contentful-articles' as const;
export const  BonusReportsKey: string = 'contentful-bonus-reports' as const;
export const  CoursesKey: string = 'contentful-courses' as const;
export const  FreemiumContentPermissionKey: string = 'freemium' as const;
export const  ModelPortfoliosPermissionsKey: string = 'model-portfolios' as const;
export const  PermissionsKey: string = 'permissions' as const;
export const  PublicContentPermissionKey: string = 'public' as const;
export const  TmiPermissionsKey: string = 'tmi' as const;
export const  TmiPublicContentPermissionKey: string = 'true-market-insiders' as const;
export const  TmiPublicContentNonHyphenated: string = 'true market insiders' as const;
export const  WebinarsKey: string = 'contentful-webinars' as const;

export const  AllSectorBullishPercentIndexesPermissionKey: string = 'all-bpis' as const;
export const  ArticlesPermissionKey: string = 'articles' as const;
export const  BonusReportsPermissionKey: string = 'bonus-reports' as const;
export const  CoursePermissionsKey: string = 'courses' as const;
export const  DashboardPermissionKey: string = 'dashboard' as const;
export const  EtfListingPermissionsKey: string = 'etf-listing' as const;
export const  EtfPermissionsKey: string = 'etfs' as const;
export const  MainSearchPermissionKey: string = 'main-search' as const;
export const  MajorIndexBreadthPermissionsKey: string = 'major-index-breadth' as const;
export const  NyseBpiPermissionKey: string = 'nyse-bpi' as const;
export const  OptionsCalculatorPermissionKey: string = 'options-calculator' as const;
export const  OptionsQuotesPermissionKey: string = 'options-quotes' as const;
export const  PortfolioBuilderPermissionKey: string = 'position-key' as const;
export const  PositionSizeCalculatorPermissionKey: string = 'position-size-calculator' as const;
export const  ProductTradeAlertsPermissionKey: string = 'trade-alerts' as const;
export const  ProfilePermissionKey: string = 'profile' as const;
export const  RelativeStrengthMatrixPermissionKey: string = 'rs-matrix' as const;
export const  RequestNewFeaturesPermissionKey: string = 'request-new-feature' as const;
export const  ScannerPermissionKey: string = 'scanner' as const;
export const  SectorAlertsPermissionKey: string = 'alerts' as const;
export const  SectorBreadthPermissionKey: string = 'sector-breadth' as const;
export const  SectorsPermissionKey: string = `${ Sectors }` as const;
export const  SectorTreePermissionKey: string = `${ Sectors }` as const;
export const  SpreadCalculatorsPermissionKey: string = 'spread-calculators' as const;
export const  StockPermissionsKey: string = 'stocks' as const;
export const  WebinarsPermissionsKey: string = 'webinars' as const;

/************************* ROUTE/ROUTER Constants ************************/

/*--------------------------- Public Page Path & Name Constants ---------------------------*/
export const  AboutUsName: string = `about-us` as const;
export const  AboutUsPath: string = `/${ AboutUsName }` as const;
export const  AboutVersionName: string = `about-version` as const;
export const  AboutVersionPath: string = `/${ AboutVersionName }` as const;
export const  ContactUsSlug: string = `contact-us` as const;
export const  ContactUsDisplayText: string = 'Contact Us' as const;
export const  ContactUsPath: string = `/${ ContactUsSlug }` as const;
export const  DashboardName: string = "dashboard" as const;
export const  DashboardPath: string = `/${ DashboardName }` as const;

export const  ForbiddenName: string = `access-required` as const;
export const  ForbiddenPath: string = `/${ ForbiddenName }` as const;
export const  HomeName: string = `home` as const;
export const  HomePath: string = `/` as const;
export const  MediaSlug: string = 'media' as const;
export const  MediaPath: string = `/${ MediaSlug }` as const;
export const  NewPasswordName: string = `new-password` as const;
export const  NewPasswordPath: string = `/${ NewPasswordName }/:token/:email` as const;
export const  PrivacyPolicySlug: string = 'privacy-policy' as const;
export const  PrivacyPolicyDisplayText: string = 'Privacy Policy' as const;
export const  PrivacyPolicyPath: string = `/${ PrivacyPolicySlug }` as const;
export const  ProfileName: string = 'profile' as const;
export const  ProfilePath: string = `/${ ProfileName }` as const;
export const  RefundPolicySlug: string = 'refund-policy' as const;
export const  RefundPolicyDisplayText: string = 'Refund Policy' as const;
export const  RefundPolicyPath: string = `/${ RefundPolicySlug }` as const;
export const  ResetPasswordName: string = `reset-password` as const;
export const  ResetPasswordPath: string = `/${ ResetPasswordName }` as const;
export const  SignInName: string = `sign-in` as const;
export const  SignInPath: string = `/${ SignInName }` as const;
export const  SignInAsUserName: string = `sign-in-as-a-user` as const;
export const  SignInAsUserPath: string = `${ SignInPath }/:token` as const;
export const  SignUpName: string = `sign-up` as const;
export const  SignUpPath: string = `/${ SignUpName }` as const;
export const  SmsTextPolicySlug: string = `sms-text-policy` as const;
export const  SmsTextPolicyDisplayText: string = `SMS Text Policy` as const;
export const  SmsTextPolicyPath: string = `/${ SmsTextPolicySlug }` as const;
export const  TermsOfUsePolicySlug: string = `terms-of-use` as const;
export const  TermsOfUsePolicyDisplayText: string = `Terms & Conditions` as const;
export const  TermsOfUsePolicyPath: string = `/${ TermsOfUsePolicySlug }` as const;
export const  WhitelistInstructionsSlug: string = `whitelist-instructions` as const;
export const  WhitelistInstructionsDisplayText: string = `Whitelist Instructions` as const;
export const  WhitelistInstructionsPath: string = `/${ WhitelistInstructionsSlug }` as const;

/*------------------------- Learning/Course Path & Name Constants -------------------------*/
export const  LearningName: string = `learning` as const;
export const  LearningPath: string = `/${ LearningName }` as const;
export const  ArticleSearchName: string = `articles` as const;
export const  ArticleSearchPath: string = `${ LearningPath }/${ ArticleSearchName }` as const;
export const  ArticleName: string = `article` as const;
export const  ArticlePath: string = `${ LearningPath }/${ ArticleSearchName }/:slug` as const;
export const  RelatedArticlesPath: string = `${ LearningPath }/${ Tags }/:slug` as const;
export const  TagPath: string = `${ LearningPath }/tags/:slug` as const;

export const  AuthorsName: string = `authors` as const;
export const  AuthorsPath: string = `${ LearningPath }/${ AuthorsName }` as const;
export const  AuthorBioName: string = `author` as const;
export const  AuthorBioPath: string = `${ AuthorsPath }/:slug` as const;
export const  CoursesName: string = `courses` as const;
export const  CoursesPath: string = `${ LearningPath }/${ CoursesName }` as const;
export const  CourseName: string = `course` as const;
export const  CourseSlugKey: string = `:courseSlug` as const;
export const  CoursePath: string = `${ CoursesPath }/${ CourseSlugKey }` as const;
export const  WebinarsName: string = `webinars` as const;
export const  WebinarSearchPath: string = `${ LearningPath }/${ WebinarsName }` as const;
export const  All: string = `all` as const;
export const  Completed: string = `completed` as const;
export const  Main: string = `main` as const;
export const  Upcoming: string = `upcoming` as const;
export const  WebinarAllAliasPath: string = `${ WebinarSearchPath }/${ All }` as const;
export const  WebinarCompletedAliasPath: string = `${ WebinarSearchPath }/${ Completed }` as const;
export const  WebinarMainAliasPath: string = `${ WebinarSearchPath }/${ Main }` as const;
export const  WebinarUpcomingAliasPath: string = `${ WebinarSearchPath }/${ Upcoming }` as const;
export const  WebinarName: string = `webinar` as const;
export const  WebinarPath: string = `${ LearningPath }/${ WebinarsName }/:slug` as const;

/*------------------------------ Tools Path & Name Constants ------------------------------*/
export const  NyseBpiName: string = 'bpi' as const;
export const  NyseBpiPath: string = `/${ NyseBpiName }` as const;

/*----------------------------- Product Path & Name Constants -----------------------------*/
export const  ProductsName: string = `products` as const;
export const  ProductsPath: string = `/${ ProductsName }/:productSlug` as const;
export const  ProductsAdvancedAliasName: string = 'products-advanced' as const;
export const  ProductsAdvancedAliasPath: string = `/${ ProductsAdvancedAliasName }/:productSlug` as const;

/*------------------------------ Alerts Path & Name Constants -----------------------------*/
export const  AlertsName: string = `alerts` as const;
export const  TradeAlertsName: string = `trade-alerts` as const;
export const  TradeAlertsPath: string = `/${ TradeAlertsName }` as const;
export const  TradeAlertName: string = `trade-alert` as const;
export const  TradeAlertPath: string = `${ TradeAlertsPath }/:slug` as const;
export const  LearningTradeAlertsAliasPath: string = `${ LearningPath }/${ AlertsName }` as const;
export const  LearningTradeAlertAliasPath: string = `${ LearningPath }/${ AlertsName }/:slug` as const;
export const  SectorAlertsName: string = `sector-alerts` as const;
export const  SectorAlertsPath: string = `/${ SectorAlertsName }` as const;
export const  AlertsAliasPath: string = `/${ Alerts }` as const;

/*------------------------------ Tools Path & Name Constants ------------------------------*/
export const  ToolsName: string = `tools` as const;
export const  ToolsPath: string = `/${ ToolsName }` as const;
export const  FavoritesSlug: string = `favorites` as const;
export const  AllSectorBPIsName: string = `all-bpis` as const;
export const  AllSectorBPIsPath: string = `${ ToolsPath }/${ AllSectorBPIsName }` as const;
export const  SectorBullishPercentIndicesName: string = `sector-bpis` as const;
export const  SectorBullishPercentIndicesPath: string = `${ ToolsPath }/${ SectorBullishPercentIndicesName }` as const;
export const  RelativeStrengthMatrixName: string = `rs-matrix` as const;
export const  RelativeStrengthMatrixPath: string = `${ ToolsPath }/${ RelativeStrengthMatrixName }` as const;
export const  RelativeStrengthMatrixHistoryName: string = `ranking-history` as const;
export const  RelativeStrengthMatrixHistoryPath: string = `/${ RelativeStrengthMatrixHistoryName }/:sectorId` as const;
export const  MatrixHubRelativeStrengthPath: string = `${ ToolsPath }/matrix-hub${ RelativeStrengthMatrixPath }` as const;
export const  MajorIndexBreadthName: string = `major-index-breadth` as const;
export const  MajorIndexBreadthPath: string = `${ ToolsPath }/${ MajorIndexBreadthName }` as const;
export const  OptionsName: string = `options` as const;
export const  EtfListingName: string = `etf-listing` as const;
export const  EtfListingPath: string = `${ ToolsPath }/${ EtfListingName }` as const;
export const  SectorTreeSlug: string = `sector-tree` as const;
export const  SectorTreePath: string = `${ ToolsPath }/${ SectorTreeSlug }` as const;
export const  SectorsName: string = `${ Sectors }` as const;
export const  SectorsPath: string = `/${ Sectors }` as const;
export const  SectorDetailsName: string = `${ Sectors }-details` as const;
export const  SectorDetailsPath: string = `${ SectorsPath }/:sector` as const;
export const  SectorFavoritesName: string = `${ Sectors }-${ FavoritesSlug }` as const;
export const  SectorsFavoritesPath: string = `${ SectorsPath }/${ FavoritesSlug }` as const;
export const  EtfDetailsAliasPath: string = `/etfs/:ticker` as const;
export const  StockDetailsAliasPath: string = `/stocks/:ticker` as const;
export const  SecurityDetailsBasePath: string = `/securities` as const;
export const  SecurityDetailsPath: string = `${ SecurityDetailsBasePath }/:ticker` as const;
// export const  EtfOptionsAliasPath: string = `/etfs/:ticker/${ OptionsName }` as const;
// export const  StockOptionsAliasPath: string = `/stocks/:ticker/${ OptionsName }` as const;
export const  SecurityOptionsPath: string = `/securities/:ticker/${ OptionsName }` as const;
export const  PortfoliosName: string = `portfolios` as const;
export const  PortfoliosPath: string = `${ ToolsPath }/${ PortfoliosName }` as const;
export const  PortfolioBuilderName: string = `portfolio-builder` as const;
export const  PortfolioBuilderPath: string = `${ ToolsPath }/${ PortfolioBuilderName }` as const;
// export const  OptionsCalculatorNativeName: string = `options-calculator-native` as const;
// export const  OptionsCalculatorNativePath: string = `${ ToolsPath }/${ OptionsCalculatorNativeName }` as const;
export const  OptionsCalculatorName: string = `options-calculator` as const;
export const  OptionsCalculatorPath: string = `${ ToolsPath }/${ OptionsCalculatorName }` as const;
export const  PositionSizeCalculatorName: string = `position-size-calculator` as const;
export const  PositionSizeCalculatorPath: string = `${ ToolsPath }/${ PositionSizeCalculatorName }` as const;
export const  SpreadCalculatorName: string = `spread-calculators` as const;
export const  SpreadCalculatorPath: string = `${ ToolsPath }/${ SpreadCalculatorName }` as const;

/*------------------------- Profile Path & Name Constants -------------------------*/
export const  Confirmation: string =`confirmation` as const;
export const  MyContactInfoName: string = `contact-info` as const;
export const  MyContactInfoPath: string = `${ HomePath }` as const;
export const  MyLibraryName: string = `my-library` as const;
export const  MyLibraryPath: string = `${ ProfilePath }/${ MyLibraryName }` as const;
export const  BonusReportsName: string = `bonus-reports` as const;
export const  BonusReportsSearchName: string = `bonus-reports-search` as const;
export const  BonusReportsPath: string = `${ MyLibraryPath }/${ BonusReportsName }` as const;
export const  BonusReportsSearchPath: string = `${ LearningPath }/${ BonusReportsName }` as const;
export const  BonusReportsForProductPath: string = `${ BonusReportsPath }?select-product=:productSlug` as const;
export const  GeneralFeedbackName: string = `general-feedback` as const;
export const  GeneralFeedbackPath: string = `/${ GeneralFeedbackName }` as const;
export const  GeneralFeedbackConfirmationName: string = `${ GeneralFeedbackName }-confirmation` as const;
export const  GeneralFeedbackConfirmationPath: string = `${ GeneralFeedbackPath }/${ Confirmation }` as const;
export const  MyArticlesPath: string = `${ MyLibraryPath }` as const;
export const  MyWebinarsName: string = `favorite-webinars` as const;
export const  MyWebinarsPath: string = `${ MyLibraryPath }/${ MyWebinarsName }` as const;

/*----------------------------------- Contentful category slug references -----------------------------------*/
export const  NyseBpiUpdateCategorySlug: string = `nyse-bpi-updates` as const;
